import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./config";

const CustCtx = createContext(null);
const KEY = "gefion_customer_token";

export function CustomerAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem(KEY);
    if (!t) { setLoading(false); return; }
    api.get("/customers/me", { headers: { Authorization: `Bearer ${t}` } })
      .then((r) => setUser({ ...r.data, token: t }))
      .catch(() => localStorage.removeItem(KEY))
      .finally(() => setLoading(false));
  }, []);

  const setSession = ({ token, user: u }) => {
    localStorage.setItem(KEY, token);
    setUser({ ...u, token });
  };
  const login = useCallback(async (email, password) => {
    const r = await api.post("/customers/login", { email, password });
    setSession(r.data); return r.data.user;
  }, []);
  const register = useCallback(async (payload) => {
    const r = await api.post("/customers/register", payload);
    setSession(r.data); return r.data.user;
  }, []);
  const requestMagicLink = useCallback(async (email) => {
    const r = await api.post("/customers/magic-link/request", { email });
    return r.data;
  }, []);
  const verifyMagicLink = useCallback(async (token) => {
    const r = await api.post("/customers/magic-link/verify", { token });
    setSession(r.data); return r.data.user;
  }, []);
  const logout = useCallback(() => {
    localStorage.removeItem(KEY);
    setUser(null);
  }, []);
  const authHeaders = () => (user?.token ? { Authorization: `Bearer ${user.token}` } : {});

  return (
    <CustCtx.Provider value={{ user, loading, login, register, requestMagicLink, verifyMagicLink, logout, authHeaders }}>
      {children}
    </CustCtx.Provider>
  );
}

export const useCustomer = () => useContext(CustCtx);
